<template>
    <div class="page-content">
        <slot />
    </div>
</template>

<script>
export default {
  name: 'PageContent'
}
</script>

<style lang="sass" scoped>
    .page-content
        background: white
        box-shadow: $standard-elevation
        height: 100vh
        width: calc(100% - 48rem)
        max-width: gridSteps(120)
        min-width: gridSteps(100)
        padding: gridSteps(4) gridSteps(8) gridSteps(12) gridSteps(38)
        overflow: auto

    .section
        margin-bottom: gridSteps(10)

        &:last-child
            margin-bottom: 0

    @media screen and (max-width: 1200px)
        .page-content
            max-width: calc(100% - 10rem)
</style>
